/**
 * CameraSwitchButton — flip between front and back camera (FR-001 / FR-007).
 *
 * Shown in the Controls toolbar only when the device reports ≥ 2 video-input
 * cameras AND the camera is currently on (canSwitchCamera predicate).
 *
 * Accessibility: real <button>, i18n aria-label, matches the Controls .btn
 * style so it gets the same 44px touch target (FR-007).
 */
import { useTranslation } from 'react-i18next'
import styles from './Controls.module.css'

interface CameraSwitchButtonProps {
  onSwitchCamera: () => void
}

export function CameraSwitchButton({ onSwitchCamera }: CameraSwitchButtonProps) {
  const { t } = useTranslation()

  return (
    <button
      data-testid="control-camera-switch"
      className={`${styles.btn} ${styles.btnOn}`}
      aria-label={t('controls.switchCamera')}
      onClick={onSwitchCamera}
      type="button"
    >
      <SwitchCameraIcon />
      <span className={styles.btnLabel}>{t('controls.switchCamera')}</span>
    </button>
  )
}

function SwitchCameraIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* Simple circular rotate arrows */}
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  )
}
